import type { TranslationDict } from '../en';

const hi: TranslationDict = {
  'header.buy': 'खरीदें',
  'header.sell': 'बेचें',
  'spend.label': 'आप खर्च करते हैं',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'आपको मिलेगा',
  'payment.label': 'भुगतान विधि',
  'payment.select': 'चुनें',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'इस जोड़ी के लिए कोई भुगतान विधि उपलब्ध नहीं',
  'wallet.label': 'प्राप्तकर्ता वॉलेट पता',
  'wallet.placeholderBuy': 'अपना प्राप्तकर्ता पता दर्ज करें',
  'wallet.placeholderSell': 'अपना भेजने वाला पता दर्ज करें',
  'wallet.validating': 'पता सत्यापित हो रहा है...',
  'wallet.invalid': 'एक मान्य वॉलेट पता दर्ज करें',
  'wallet.invalidServer': 'अमान्य वॉलेट पता',
  'cta.buy': '{crypto} खरीदें',
  'cta.sell': '{crypto} बेचें',
  'cta.gettingPrice': 'सर्वोत्तम मूल्य प्राप्त हो रहा है...',
  'cta.processing': 'प्रोसेस हो रहा है...',
  'footer.poweredBy': 'द्वारा संचालित ',
  'footer.brand': 'NowRamp',
  'rate.title': 'दर विवरण',
  'rate.close': 'बंद करें',
  'rate.updatesIn': 'दर 00:{seconds} में अपडेट होगी',
  'rate.noQuote': 'कोई कोटेशन उपलब्ध नहीं',
  'rate.exchangeRate': 'विनिमय दर',
  'rate.processingFee': 'प्रोसेसिंग शुल्क',
  'rate.networkFee': 'नेटवर्क शुल्क',
  'rate.provider': 'प्रदाता',
  'toast.orderCreated': 'ऑर्डर बनाया गया',
  'toast.redirecting': 'चेकआउट पर रीडायरेक्ट हो रहा है...',
  'toast.orderFailed': 'ऑर्डर विफल',
  'toast.couldNotCreate': 'ऑर्डर नहीं बनाया जा सका',
  'toast.quoteError': 'कोटेशन त्रुटि',
  'toast.noProviders': 'कोई प्रदाता नहीं',
  'toast.somethingWrong': 'कुछ गलत हो गया',
  'error.amountZero': 'राशि 0 से अधिक होनी चाहिए',
  'error.minAmountFiat': 'न्यूनतम राशि {min} {currency} है',
  'error.minAmountCrypto': 'न्यूनतम राशि {min} {currency} है',
  'error.noProviders': 'इस संयोजन के लिए कोई प्रदाता उपलब्ध नहीं',
  'error.currencyUnavailableBuy': 'यह मुद्रा खरीद ऑर्डर के लिए उपलब्ध नहीं है',
  'error.currencyUnavailableSell': 'यह मुद्रा बिक्री ऑर्डर के लिए उपलब्ध नहीं है',
  'parity.info': 'आपसे {receiveAmount} {crypto} के लिए शुल्क लिया जाएगा, शेष {spendAmount} {fiat} तक आपके {partner} खाते में जमा किया जाएगा',
  'redirect.secureBadge': 'सुरक्षित भुगतान',
  'redirect.title': 'भुगतान जारी रखें',
  'redirect.description': 'भुगतान पूरा करने के लिए आपको {gateway} पर रीडायरेक्ट किया जाएगा।',
  'redirect.countdown': '{seconds} में रीडायरेक्ट हो रहा है...',
  'redirect.openTab': 'नई टैब में ACH खोलें',
  'redirect.cancel': 'रद्द करें',
  'checkout.noOrder': 'कोई ऑर्डर नहीं मिला',
  'checkout.goBack': 'वापस जाएं',
  'checkout.expired': 'चेकआउट समाप्त हो गया',
  'checkout.expiredDesc': 'सत्र समाप्त हो गया है। कृपया पुनः प्रयास करें।',
  'checkout.startOver': 'फिर से शुरू करें',
  'checkout.cancel': 'रद्द करें',
  'checkout.loading': 'चेकआउट लोड हो रहा है...',
  'checkout.iframeTitle': 'प्रदाता चेकआउट',
  'checkout.widgetTitle': 'भुगतान चेकआउट',
  'checkout.unknownMethod': 'अज्ञात चेकआउट विधि',
  'processing.default': 'आपका ऑर्डर प्रोसेस हो रहा है...',
  'processing.pending': 'भुगतान पुष्टि की प्रतीक्षा हो रही है...',
  'processing.active': 'आपका लेनदेन प्रोसेस हो रहा है...',
  'processing.generic': 'प्रोसेस हो रहा है...',
  'processing.checkingStatus': 'स्थिति जाँची जा रही है...',
  'processing.orderId': 'ऑर्डर आईडी',
  'processing.provider': 'प्रदाता',
  'processing.amount': 'राशि',
  'processing.receiving': 'प्राप्त हो रहा है',
  'processing.network': 'नेटवर्क',
  'processing.toAddress': 'प्राप्तकर्ता पता',
  'processing.usuallyMinutes': 'इसमें आमतौर पर कुछ मिनट लगते हैं।',
  'processing.safeToClose': 'आप इस पेज को सुरक्षित रूप से बंद कर सकते हैं - पूरा होने पर हम आपको ईमेल भेजेंगे।',
  'complete.buyTitle': 'खरीदारी पूर्ण!',
  'complete.sellTitle': 'बिक्री पूर्ण!',
  'complete.buyDesc': 'आपका {crypto} आपके वॉलेट में भेज दिया गया है।',
  'complete.sellDesc': 'आपका {fiat} भुगतान प्रोसेस हो रहा है।',
  'complete.amountBuy': 'प्राप्त राशि',
  'complete.amountSell': 'बेची गई राशि',
  'complete.paidBuy': 'भुगतान की गई राशि',
  'complete.paidSell': 'भुगतान राशि',
  'complete.network': 'नेटवर्क',
  'complete.wallet': 'वॉलेट',
  'complete.transaction': 'लेनदेन',
  'complete.provider': 'प्रदाता',
  'complete.orderId': 'ऑर्डर आईडी',
  'complete.completed': 'पूर्ण',
  'complete.viewExplorer': 'एक्सप्लोरर पर देखें',
  'complete.done': 'हो गया',
  'errorStep.failed': 'भुगतान विफल',
  'errorStep.cancelled': 'ऑर्डर रद्द',
  'errorStep.expired': 'ऑर्डर समाप्त',
  'errorStep.refunded': 'ऑर्डर वापस किया गया',
  'errorStep.unknown': 'कुछ गलत हो गया',
  'errorStep.failedBuy': 'आपका भुगतान प्रोसेस नहीं हो सका। कृपया पुनः प्रयास करें या किसी अन्य भुगतान विधि का उपयोग करें।',
  'errorStep.failedSell': 'आपकी बिक्री प्रोसेस नहीं हो सकी। कृपया पुनः प्रयास करें।',
  'errorStep.cancelledBuy': 'आपका ऑर्डर रद्द कर दिया गया। कोई भुगतान प्रोसेस नहीं किया गया।',
  'errorStep.cancelledSell': 'आपकी बिक्री रद्द कर दी गई। कोई क्रिप्टो ट्रांसफर नहीं किया गया।',
  'errorStep.expiredBuy': 'आपका ऑर्डर समाप्त हो गया है। कृपया नई खरीदारी शुरू करें।',
  'errorStep.expiredSell': 'आपका ऑर्डर समाप्त हो गया है। कृपया नई बिक्री शुरू करें।',
  'errorStep.refundedBuy': 'आपका भुगतान वापस कर दिया गया है। राशि 5-10 कार्यदिवसों में आपके खाते में दिखाई देगी।',
  'errorStep.refundedSell': 'आपका क्रिप्टो वापस कर दिया गया है। राशि जल्द ही आपके वॉलेट में दिखाई देगी।',
  'errorStep.genericDesc': 'एक अप्रत्याशित त्रुटि हुई। कृपया पुनः प्रयास करें।',
  'errorStep.orderId': 'ऑर्डर आईडी',
  'errorStep.tryAgain': 'पुनः प्रयास करें',
  'errorStep.startOver': 'फिर से शुरू करें',
  'errorStep.return': 'वापस जाएं',
  'errorStep.needHelp': 'सहायता चाहिए? संपर्क करें ',
  'errorStep.reference': 'संदर्भ: {orderId}',
  'confirm.buyTitle': 'खरीदारी की पुष्टि करें',
  'confirm.sellTitle': 'बिक्री की पुष्टि करें',
  'confirm.loading': 'लोड हो रहा है...',
  'confirm.provider': 'प्रदाता',
  'confirm.youPay': 'आप भुगतान करते हैं',
  'confirm.youSell': 'आप बेचते हैं',
  'confirm.youReceive': 'आपको मिलेगा',
  'confirm.wallet': 'वॉलेट',
  'confirm.network': 'नेटवर्क',
  'confirm.refundAddress': 'वापसी पता',
  'confirm.parityNote': 'प्रदाता से ली गई राशि भिन्न हो सकती है। शेष {amount} {crypto} तक आपके {partner} खाते में जमा किया जाएगा।',
  'confirm.processing': 'प्रोसेस हो रहा है...',
  'confirm.confirmPay': 'पुष्टि करें और भुगतान करें',
  'confirm.confirmSell': 'पुष्टि करें और बेचें',
  'confirm.payout': '{currency} भुगतान',
  'modal.selectFiat': 'फिएट मुद्रा चुनें',
  'modal.selectCrypto': 'क्रिप्टो मुद्रा चुनें',
  'modal.choosePayment': 'भुगतान विधि चुनें',
  'modal.selectCountry': 'अपना देश चुनें',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'लोकप्रिय',
  'modal.recommended': 'अनुशंसित',
  'modal.noCurrencies': 'कोई मुद्रा नहीं मिली',
  'modal.noPaymentMethods': 'कोई भुगतान विधि नहीं मिली',
  'modal.noCountries': 'कोई देश नहीं मिला',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'स्थान',
  'settings.darkMode': 'डार्क मोड',
  'settings.privacy': 'गोपनीयता नीति',
  'settings.terms': 'उपयोग की शर्तें',
  'settings.language': 'भाषा',
  // ─── Additional ───
  'modal.chooseRamp': 'Ramp चुनें',
  'modal.bestPrice': 'सर्वोत्तम मूल्य',
  'modal.noQuotes': 'इस अनुरोध के लिए कोई कोटेशन उपलब्ध नहीं',
  'modal.noProvidersFound': 'कोई प्रदाता नहीं मिला',
  'payment.unavailableFor': '{currency} के लिए कोई भुगतान विधि उपलब्ध नहीं',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': 'ऑर्डर बनाने में विफल',
  'errorStep.returnToMerchant': 'व्यापारी के पास वापस जाएं',
  'confirm.cryptoOnNetwork': '{crypto} {network} पर',
  'payment.name.card': 'कार्ड',
  'payment.name.bankTransfer': 'बैंक ट्रांसफर',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default hi;
